import { BannerPage } from "../../uiLibrary/bannerPage/BannerPage";
import { useCallback } from "react";
import { Button } from "../../uiLibrary/button";
import { useSingleton } from "../../other/injection";
import { MessageBusService } from "../../other/messageBus/MessageBusService";

export const StopImpersonatingPage = () => {
    const messageBusService = useSingleton(MessageBusService);

    const click = useCallback(async () => {
        const command: RedDeer.Contracts.Commands.User.StopImpersonationCommand =
            {
                MessageType: "Commands.User.StopImpersonationCommand"
            };
        await messageBusService.sendPromise({
            request: command,
            description: "ending impersonated session"
        });
        location.reload();
    }, [messageBusService]);

    return (
        <BannerPage title="Stop impersonating">
            <Button
                buttonType="neutral"
                testId="stopImpersonating"
                onClick={() => {
                    void click();
                }}
            >
                Stop impersonating
            </Button>
        </BannerPage>
    );
};
